import {
  init as csRenderInit,
  volumeLoader,
  metaData,
  imageLoader,
  utilities as csUtils,
  cornerstoneStreamingImageVolumeLoader,
  cornerstoneStreamingDynamicImageVolumeLoader,
} from '@cornerstonejs/core';
import cornerstoneDICOMImageLoader from '@cornerstonejs/dicom-image-loader';
import {
  cornerstoneNiftiImageLoader,
} from '@cornerstonejs/nifti-volume-loader';
import { init as csToolsInit } from '@cornerstonejs/tools';

interface InitConfig {
  core?: Parameters<typeof csRenderInit>[0];
  debug?: boolean;
}

let CORNERSTONE_INITIALIZED = false;

const scalingPerImageId: Record<string, unknown> = {};

const ptScalingMetaDataProvider = {
  addInstance(imageId: string, scalingMetaData: unknown) {
    const imageURI = csUtils.imageIdToURI(imageId);
    scalingPerImageId[imageURI] = scalingMetaData;
  },
  get(type: string, imageId: string) {
    if (type === 'scalingModule') {
      const imageURI = csUtils.imageIdToURI(imageId);
      return scalingPerImageId[imageURI];
    }
  },
};

function initProviders() {
  const { calibratedPixelSpacingMetadataProvider } = csUtils;
  metaData.addProvider(
    ptScalingMetaDataProvider.get.bind(ptScalingMetaDataProvider),
    10000,
  );
  metaData.addProvider(
    calibratedPixelSpacingMetadataProvider.get.bind(
      calibratedPixelSpacingMetadataProvider,
    ),
    11000,
  );
}

function initVolumeLoader() {
  volumeLoader.registerUnknownVolumeLoader(
    // @ts-expect-error - Cornerstone's type definitions do not properly export this loader type, but runtime usage is correct.
    cornerstoneStreamingImageVolumeLoader,
  );
  volumeLoader.registerVolumeLoader(
    'cornerstoneStreamingImageVolume',
    // @ts-expect-error - Cornerstone's type definitions do not properly export this loader type, but runtime usage is correct.
    cornerstoneStreamingImageVolumeLoader,
  );
  volumeLoader.registerVolumeLoader(
    'cornerstoneStreamingDynamicImageVolume',
    // @ts-expect-error - Cornerstone's type definitions do not properly export this loader type, but runtime usage is correct.
    cornerstoneStreamingDynamicImageVolumeLoader,
  );
}

export default async function initCornerstone3D(config: InitConfig = {}) {
  // Only initialize once globally
  if (CORNERSTONE_INITIALIZED) {
    return;
  }

  initProviders();
  cornerstoneDICOMImageLoader.init();
  imageLoader.registerImageLoader(
    'nifti',
    cornerstoneNiftiImageLoader,
  );
  initVolumeLoader();
  await (csRenderInit as unknown as (configuration: unknown) => Promise<boolean>)({
    ...(config.core
      ? {
        ...config.core,
        debug: {
          statsOverlay: config.debug ?? false,
          ...config.core.debug,
        },
      }
      : {
        debug: {
          statsOverlay: config.debug ?? false,
        },
      }),
  });
  await (csToolsInit as () => Promise<void>)();

  CORNERSTONE_INITIALIZED = true;
}
export { ptScalingMetaDataProvider };
